module.exports = __webpack_public_path__ + "img/service-8.b47ad005.jpg";